import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';
import { whatsappLink } from '../config/contact';
import './WhatsAppButton.css';

/** Plutajuće dugme dole desno: otvara WhatsApp sa unapred popunjenom porukom na izabranom jeziku. */
const WhatsAppButton: React.FC = () => {
  const { t } = useLanguage();
  return (
    <a
      className="wa-float"
      href={whatsappLink(t('whatsapp.message'))}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('whatsapp.label')}
    >
      <FaWhatsapp className="wa-float__icon" aria-hidden />
      <span className="wa-float__text">{t('whatsapp.cta')}</span>
    </a>
  );
};

export default WhatsAppButton;
